<template>
    <!--       @blur="handleSearch" search on keyup -->
    <div class="filteritem">
      <v-text-field
        v-model="searchString"
        class="search font-weight-bold text-text text-subtitle-1"
        density="compact"
        variant="underlined"
        name="searchPAG"
        :label="searchLabel"
        @keyup.enter="handleSearch"
      >
        <!-- button right append-inner -->
        <template #append-inner>
            <v-icon size="20" @click="handleSearch" >mdi-magnify</v-icon>
        </template>
      </v-text-field>
    </div>
</template>
<script setup>
const dataAll = useDataAll();
const props = defineProps({

    pagData: {
        type: Object,
        default: "",
  }, 
  selectedFilters: {
        type: Object,
        default: "",
  }, 

});

const searchString = ref(props.selectedFilters['q'])
const { $PAG } = useNuxtApp()
const searchLabel = dataAll.getStatic('pag_search_placeholder','Search in results')

// search on event dont connect the model directy, otherwise every keyup event fires search api call
function handleSearch() {
    props.selectedFilters['q'] = searchString.value
}
</script>